export default "__VITE_ASSET__9zyWsPsW__"